var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.523 20 20 15.523 20 10C20 4.477 15.523 0 10 0C4.477 0 0 4.477 0 10C0 15.523 4.477 20 10 20ZM13.536 6.464C13.7238 6.27649 13.9783 6.17126 14.2437 6.17144C14.5091 6.17163 14.7635 6.27723 14.951 6.465C15.1385 6.65277 15.2437 6.90734 15.2436 7.17271C15.2434 7.43807 15.1378 7.69249 14.95 7.88L9.297 13.533L9.293 13.537C9.20035 13.6302 9.09019 13.7041 8.96885 13.7546C8.84752 13.8051 8.71741 13.831 8.586 13.831C8.45459 13.831 8.32448 13.8051 8.20315 13.7546C8.08181 13.7041 7.97165 13.6302 7.879 13.537L7.875 13.533L5.05 10.708C4.95449 10.6158 4.87831 10.5054 4.8259 10.3834C4.77349 10.2614 4.7459 10.1302 4.74475 9.9974C4.7436 9.86462 4.7689 9.73294 4.81918 9.61005C4.86946 9.48715 4.94371 9.3755 5.0376 9.2816C5.1315 9.18771 5.24315 9.11346 5.36605 9.06318C5.48894 9.0129 5.62062 8.9876 5.7534 8.98875C5.88618 8.9899 6.0174 9.01749 6.1394 9.0699C6.26141 9.12231 6.37175 9.19849 6.464 9.294L8.586 11.415L13.536 6.465V6.464Z",
    fill: "#0D85C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.f65d4ed0e85e34713803e1eb64c9c081.svg";
export { ForwardRef as ReactComponent };